export default __webpack_public_path__ + "static/media/logo-musaned-white-ar.a6723ad3.svg";